import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Newsletter",
  tags: ["#page"],
}

export default defineBlock("forms/newsletter", (props) => {
  return (
    <div
      className={cn(
        "newsletter w-full content-sized block-spacing text-white bg-blue [&_.inline-media]:!my-0 [&_.inline-media]:md:!w-auto [&_.inline-media]:md:!self-stretch [&_.inline-media-wrap]:md:!h-full [&_.inline-media-wrap]:md:!w-auto [&_.inline-media-item]:md:!h-full [&_.inline-media-item]:md:!w-auto",
      )}
    >
      <InnerBlocks
        allowedBlocks={["forms/newsletter-inner", "media/inline-media"]}
        template={[
          ["forms/newsletter-inner", {}],
          ["media/inline-media", {}],
        ]}
        className={cn(
          "w-full gap-7",
          !env.admin && "flex flex-col md:flex-row items-center justify-center md:flex-nowrap",
          env.admin && "grid grid-cols-1 md:grid-cols-2 items-center",
        )}
        templateLock="all"
      />
    </div>
  )
})
